// filepath: resources/assets/front/js/components/notifications.js

export function initNotifications(element = document) {
  // Auto-hide notifications
  element.querySelectorAll('.notification[data-auto-hide]:not([data-auto-hide-init])').forEach(notification => {
    const delay = parseInt(notification.getAttribute('data-auto-hide')) || 5000;
    
    setTimeout(() => {
      notification.classList.add('opacity-0', 'translate-x-full');
      setTimeout(() => notification.remove(), 300);
    }, delay);
    
    notification.setAttribute('data-auto-hide-init', 'true');
  });
  
  if (element === document) {
    console.log('🔔 Notifications initialized');
  }
}